import React from 'react';
import { Card, Container, Divider, Group, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

type ContainerLayoutProps = {
  icon?: React.ReactElement;
  title?: string;
  toolbar?: React.ReactNode;
  toolbarFooter?: React.ReactNode;
  children: React.ReactNode;
};

const ContainerLayout = ({
  icon,
  title,
  toolbar,
  toolbarFooter,
  children,
}: ContainerLayoutProps) => {
  const hasHeaderContent = icon || title || toolbar;
  const hasFooterContent = toolbarFooter;
  const isMobile = useMediaQuery(`(min-width: 992px)`);
  const iconSize = isMobile ? 36 : 24;
  const titleSize = isMobile ? 1 : 3;

  return (
    <Container fluid mb={20}>
      <Card shadow="xs" radius="md" withBorder>
        <Group justify="space-between" align="center">
          <Group>
            {icon && React.cloneElement(icon, { size: iconSize })}
            {title && <Title order={titleSize}>{title}</Title>}
          </Group>

          {toolbar && <Group>{toolbar}</Group>}
        </Group>

        {hasHeaderContent && <Divider mb={20} mt={10} />}

        {children}

        {hasFooterContent && <Divider mt={40} mb={10} />}
        {toolbarFooter && toolbarFooter}
      </Card>
    </Container>
  );
};

export default ContainerLayout;
